module.exports = __webpack_public_path__ + "static/media/icClicks.9370ee9f.svg";